<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-3",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 3,
      nextPage: '/questionnaire/section1/4',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'Your age:',
        btn: [
          [
            {
              text: '18-24'
            },{
              text: '25-30'
            }
          ],[
            {
              text: '31-40'
            },{
              text: '41-50'
            }
          ],[
            {
              text: '50+'
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
